import React, { useMemo } from "react";
import _ from "lodash";

import { Sportsbook } from "../../../../constants";
import styles from "./styles.scss";

export interface BookInputColumnProps {
  books: Sportsbook[];
  onChangeBook(index: number): void;
  selectedIndex: number;
  className?: string;
}

const BookInputColumn = React.memo(({ books, onChangeBook, selectedIndex, className }: BookInputColumnProps) => {
  const bookList = useMemo(() => {
    const tempBooks = _.cloneDeep(books);
    tempBooks.sort((a: Sportsbook, b: Sportsbook) => {
      if (a.rank < b.rank) {
        return -1;
      }
      if (a.rank > b.rank) {
        return 1;
      }
      return 0;
    });
    return tempBooks;
  }, [books]);
  return (
    <div className={`rotoql-input-column ${className || ""}`}>
      <div className="rotoql-input-column__text-title">SPORTS BOOK</div>
      {/* We need to sort here to ensure the list is always ranked correctly */}
      {bookList.map((book: Sportsbook, index: number) => (
        <div className="rotoql-input-column__item" key={book.name}>
          <div className="pretty p-default p-round p-bigger">
            <input
              type="radio"
              className={"rotoql-input-column__input"}
              checked={index === selectedIndex}
              onChange={() => onChangeBook(index)}
            />
            <div className="state rotoql-input-column__text">
              <label>{book.name}</label>
            </div>
          </div>
        </div>
      ))}
      <style jsx global>
        {styles}
      </style>
    </div>
  );
});

export default BookInputColumn;
